// extracted by mini-css-extract-plugin
export var button = "PhotoGallery-module--button--37049";
export var content = "PhotoGallery-module--content--2315a";
export var decor = "PhotoGallery-module--decor--a1122";
export var gallery = "PhotoGallery-module--gallery--69b46";
export var galleryContainer = "PhotoGallery-module--galleryContainer--d8a46";
export var image = "PhotoGallery-module--image--ff0ac";
export var left = "PhotoGallery-module--left--d0fcf";
export var lineAbove = "PhotoGallery-module--lineAbove--77a4a";
export var logo = "PhotoGallery-module--logo--b28af";
export var next = "PhotoGallery-module--next--93810";
export var prev = "PhotoGallery-module--prev--b89cc";
export var relativeWrapper = "PhotoGallery-module--relativeWrapper--a4725";
export var thumb = "PhotoGallery-module--thumb--d640d";